import { render, staticRenderFns } from "./ListeProduitsTuiles.vue?vue&type=template&id=2404f920"
import script from "./ListeProduitsTuiles.vue?vue&type=script&lang=js"
export * from "./ListeProduitsTuiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports